import { TIdToPageConfigMap } from 'models/common.model'
import { HeaderId } from 'nove8/constants/root-constants'
import { PageIdStylioArch81 } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_STYLIO_ARCH_81: TIdToPageConfigMap = {
  [PageIdStylioArch81.SUBSCRIPTIONS_ARCH_81]: {
    id: PageIdStylioArch81.SUBSCRIPTIONS_ARCH_81,
  },
  [PageIdStylioArch81.SUB_UPSELL_ARCH_81]: {
    id: PageIdStylioArch81.SUB_UPSELL_ARCH_81,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioArch81.FACE_STYLING_PDF_UPSELL_ARCH_81]: {
    id: PageIdStylioArch81.FACE_STYLING_PDF_UPSELL_ARCH_81,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioArch81.PROPORTIONS_PDF_UPSELL_ARCH_81]: {
    id: PageIdStylioArch81.PROPORTIONS_PDF_UPSELL_ARCH_81,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioArch81.DOWNLOAD_ARCH_81]: {
    id: PageIdStylioArch81.DOWNLOAD_ARCH_81,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
}
